import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import _ from "lodash";
import TableCollaborator from "../../TableCollaborator/TableCollaborator";
import moment from "moment";
moment.locale("es");
export default defineComponent({
  name: "license",
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    objectEdit: {
      type: Object,
      required: false,
      default: () => ({
        collaborators: Array,
      }),
    },
  },
  computed: {
    headerImg() {
      return this.backendPath.concat(`/${this.petitioner.template_img}`);
    },
    petitioner() {
      const { name, core_role, template, site } =
        this.getLicenseGetter.petitioner || {};
      return {
        name: name || "<Petitioner name>",
        role_name: core_role ? core_role.name : "<Petitioner role>",
        template_img: template ? template.header_img : "#",
        footer_img: template ? template.footer_img : "#",
        city: site
          ? site.city
            ? this.capitalizeText(site.city.name)
            : "<Petitioner city>"
          : "<Petitioner city>",
      };
    },
    licenseEmployee() {
      return this.getLicenseGetter.license_employees || {};
    },
    createdAt() {
      return this.getLicenseGetter.created_at || "";
    },
    businessPartner() {
      const { name, society, core_role } = this.getLicenseGetter.bp || {};
      return {
        name: name || "<BP name>",
        society: society ? society.name : "<BP society>",
        role: core_role ? core_role.name : "<BP role>",
      };
    },
    laborUnionName() {
      return this.getLicenseGetter.labor_union
        ? this.getLicenseGetter.labor_union.name
        : null;
    },
    licenseEmployeeCount() {
      return this.getLicenseGetter.license_employees_count || 0;
    },
    getFirstCoreEmployee() {
      return _.head(this.licenseEmployee) || {};
    },
    getFistsTicket() {
      return this.getFirstCoreEmployee.ticket || {};
    },
    getDay() {
      return this.getFirstCoreEmployee.days
        ? this.getFirstCoreEmployee.days.at(-1).day
        : this.get_today;
    },
    tickets() {
      return this.getLicenseGetter.tickets || false;
    },
    additionalInformation() {
      return this.getLicenseGetter.additionalInfo
        ? this.getLicenseGetter.additionalInfo.toLowerCase().trim()
        : false;
    },
    getFirstCollaborator() {
      const { name, sharp_id, cc } =
        this.getFirstCoreEmployee.core_employee || {};
      return {
        name: name || "<Colaborador name>",
        sharp_id: sharp_id || "<Colaborador sharp id>",
        cc: cc || "<Colaborador identification>",
      };
    },
    getCountCollaborators() {
      return this.isEdit
        ? this.isEditParams.count_collaborators
        : this.licenseEmployeeCount;
    },
    templateLicense() {
      const { template } = this.getLicenseGetter.petitioner || {};
      return {
        signature_one: template
          ? this.backendPath.concat(`/${template.signature1}`)
          : "#",
        name_one: template ? template.name1 : "<Name presidente>",
        position_one: template ? template.position1 : "Presidente",
        signature_two: template
          ? this.backendPath.concat(`/${template.signature2}`)
          : "#",
        name_two: template ? template.name2 : "<Name secretario>",
        position_two: template ? template.position2 : "Secretario",
      };
    },
    ...mapGetters("permisosSindicalesV2License", ["getLicenseGetter"]),
    /**
     * Si es editable
     */
    isEditParams() {
      return {
        header_img: this.user.template_header_img
          ? this.backendPath.concat(`/${this.user.template_header_img}`)
          : "#",
        current_city: this.user.city_name || null,
        template_name_one: this.user.template_name_one || "<Name presidente>",
        template_position_one: this.user.template_position_one || "Presidente",
        template_signature_one: this.user.template_signature_one
          ? this.backendPath.concat(`/${this.user.template_signature_one}`)
          : "#",
        template_name_two: this.user.template_name_two || "<Name secretario>",
        template_position_two: this.user.template_position_two || "Secretario",
        template_signature_two: this.user.template_signature_two
          ? this.backendPath.concat(`/${this.user.template_signature_two}`)
          : "#",
        destination_city_name: this.objectEdit.destination_city_name || null,
        business_partner_society:
          this.objectEdit.business_partner_society || null,
        business_partner_name: this.objectEdit.business_partner_name || "",
        business_partner_role: "Business Partner",
        labor_union: this.user.labor_union_admin_name,
        petitioner_name: this.user.name,
        motive: this.objectEdit.motive
          ? `${this.objectEdit.motive.toLowerCase().trim()}.`
          : null,
        additional_information: this.objectEdit.additional_information || null,
        count_collaborators: this.objectEdit.collaborators.length || 0,
        tickets: this.objectEdit.tickets || false,
        ticket_type: this.objectEdit.ticket_type || "",
        start_date: this.objectEdit.start_date || "",
        end_date: this.objectEdit.end_date || "",
        origin_city_name: this.objectEdit.origin_city_name || "",
        collaborators: this.objectEdit.collaborators || [],
      };
    },
    isEditGetFistCollaborator() {
      return _.head(this.objectEdit.collaborators) || {};
    },
    isEditDates() {
      if (this.isEditParams.start_date && this.isEditParams.end_date) {
        const start_date = new Date(this.isEditParams.start_date);
        const end_date = new Date(this.isEditParams.end_date);
        let response = [];
        while (end_date.getTime() >= start_date.getTime()) {
          start_date.setDate(start_date.getDate() + 1);
          response.push(
            start_date.getFullYear() +
              "-" +
              (start_date.getMonth() + 1) +
              "-" +
              start_date.getDate()
          );
        }
        return response;
      }
      return [];
    },
    ...mapGetters("modEditLetter", ["getTemplateGetter"]),
    items() {
      const me = this;
      let records = [];

      if (me.isEdit) {
        me.fields = [];
        me.addColumns(me.isEditParams?.tickets);

        if (me.getCountCollaborators > 1) {
          me.isEditParams.collaborators.forEach((collaborator) => {
            records.push({
              collaborator: collaborator?.name,
              sharp_id: collaborator?.sharp_id,
              identification: collaborator?.cc,
              dates: me.daysOrderMonth(me.isEditDates),
              days: null,
              ticket: {
                type: me.isEditParams?.ticket_type?.toLowerCase(),
                city: me.isEditParams?.origin_city_name,
                origin_department: null,
                destination: me.isEditParams?.destination_city_name,
                destination_department: null,
              },
            });
          });
        } else {
          records = [
            {
              collaborator: me.isEditGetFistCollaborator.name,
              sharp_id: me.isEditGetFistCollaborator.sharp_id,
              identification: me.isEditGetFistCollaborator.cc,
              days: null,
              dates: me.daysOrderMonth(me.isEditDates),
              ticket: {
                type: me.isEditParams?.ticket_type?.toLowerCase(),
                city: me.isEditParams?.origin_city_name,
                origin_department: null,
                destination: me.isEditParams?.destination_city_name,
                destination_department: null,
              },
            },
          ];
        }
      } else {
        me.addColumns(me.tickets);

        if (me.getCountCollaborators > 1) {
          me.licenseEmployee.forEach(({ core_employee, days, ticket }) => {
            records.push({
              collaborator: core_employee?.name,
              sharp_id: core_employee?.sharp_id,
              identification: core_employee?.cc,
              dates: me.daysOrderMonth(days),
              days: null,
              ticket: {
                type: ticket?.type?.toLowerCase(),
                city: ticket?.origin_city?.name,
                origin_department: ticket?.origin_city?.department_?.name,
                destination: ticket?.destination_city_name,
                destination_department:
                  ticket?.destination_department?.name.toLowerCase(),
              },
            });
          });
        } else {
          records = [
            {
              collaborator: me.getFirstCollaborator?.name,
              sharp_id: me.getFirstCollaborator?.sharp_id,
              identification: me.getFirstCollaborator?.cc,
              dates: me.daysOrderMonth(me.getFirstCoreEmployee?.days),
              days: null,
              ticket: {
                type: me.getFistsTicket?.type?.toLowerCase(),
                city: me.getFistsTicket?.origin_city?.name,
                origin_department:
                  me.getFistsTicket?.origin_city?.department_?.name,
                destination: me.getFistsTicket?.destination_city_name,
                destination_department:
                  me.getFistsTicket?.destination_department?.name.toLowerCase(),
              },
            },
          ];
        }
      }
      return records;
    },
    textTickets() {
      const me = this;
      let text = "con";

      if (me.isEdit) {
        text = me.isEditParams.tickets ? "con" : "sin";
      } else {
        text = me.tickets ? "con" : "sin";
      }
      return text;
    },
  },
  methods: {
    daysOrderMonth(items) {
      let days = [];

      items?.forEach((day) => {
        const date = day?.day ? day?.day : day;
        const month = moment(date).format("MMMM");
        const record = days.find((item) => item.month === month);

        if (record) {
          record.dates.push(date);
        } else {
          days.push({
            month: month,
            dates: [date],
          });
        }
      });
      return days;
    },
    addColumns(value) {
      const me = this;
      me.fields = me.removeColumns(value);
    },
    removeColumns(value) {
      let fields = [];
      let fieldsInitial = [
        {
          key: "collaborator",
          label: "Colaborador",
        },
        {
          key: "sharp_id",
          label: "Sharp ID",
        },
        {
          key: "identification",
          label: "Cédula",
        },
        {
          key: "date",
          label: "Fecha",
        },
      ];

      if (value) {
        fields = [
          {
            key: "city_initial",
            label: "Desde",
          },
          {
            key: "city_final",
            label: "Hacia",
          }
        ]
      } else {
        fields = [
          {
            key: "city",
            label: "Ciudad",
          }
        ]
      }

      const fields2 = fieldsInitial.concat(fields)

      return fields2;
    },
  },
  components: {
    TableCollaborator,
  },
  data() {
    return {
      fields: [
        {
          key: "collaborator",
          label: "Colaborador",
        },
        {
          key: "sharp_id",
          label: "Sharp ID",
        },
        {
          key: "identification",
          label: "Cédula",
        },
        {
          key: "date",
          label: "Fecha",
        },
      ],
    };
  },
});
